module.exports = __webpack_public_path__ + "img/RYPL.60c2e61a.png";